import { useEffect, useRef, useState } from "react";
import {
    Box,
    Card,
    Stack,
    Typography,
    Button,
    Divider,
    Modal,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import Scrollbar from "src/components/scrollbar/Scrollbar";
import { HotTable } from '@handsontable/react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorModal from "src/components/FastReportErrorModal/ErrorModal";
import Handsontable from 'handsontable';
import Services from "src/services/Services";
import { WarningOutlined } from '@mui/icons-material';
import { registerAllModules } from "handsontable/registry";

registerAllModules();

export default function TaxFreeReport({ parsedUser, language, tabs }) {
    const calculatedHeight = window.innerHeight - 250;
    const initialRows = Array.from({ length: 50 }, (_, index) => ({
        id: index + 1,
        brand: '',
        operationDate: '',
        customerInvoiceNo: '',
        customerName: '',
        country: '',
        price: '',
        returnPrice: '',
        paymentType: '',
        store: '',
        staff: '',
        storeLocation: '',
        additionalNote: '',
    }));

    const [tableData, setTableData] = useState(initialRows);
    const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [failedRowsCount, setFailedRowsCount] = useState(0);
    const [modalType, setModalType] = useState('success');
    const hotRef = useRef(null);

    function convertDateFormat(dateStr) {
        if (!dateStr || typeof dateStr !== 'string') {
            return '';
        }
        const parts = dateStr.split('/');
        if (parts.length !== 3) {
            return dateStr;
        }
        const [day, month, year] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    const getColumnHeaders = () => [
        'NO',
        'MARKA',
        'İŞLEM TARİHİ',
        'MÜŞTERİ FATURA NO',
        'MÜŞTERİ İSMİ',
        'ÜLKE',
        'FATURA TUTARI',
        'ÖDENEN İADE TUTARI',
        'ÖDEME TÜRÜ',
        'MAĞAZA',
        'LOKASYON',
        'EP ÇALIŞANI',
        'MAĞAZA LOKASYONU',
        'NOT',
    ];

    const getColumnSettings = () => {
        const headers = getColumnHeaders();
        return headers.map((header) => {
            if (header === 'NO') {
                return {
                    data: null,
                    readOnly: true,
                    className: 'htCenter htMiddle',
                    renderer: (instance, td, row) => {
                        Handsontable.dom.empty(td);
                        Handsontable.dom.fastInnerHTML(td, row + 1);
                        return td;
                    },
                };
            }
            if (header === 'MARKA') {
                return {
                    type: 'dropdown',
                    strict: true,
                    allowInvalid: false,
                    className: 'htCenter htMiddle',
                    source: ["GLOBAL BLUE", "JOY REFUND", "PLANET", "FREEZONE"]

                };
            }
            if (header === 'ÖDEME TÜRÜ') {
                return {
                    type: 'dropdown',
                    strict: true,
                    allowInvalid: false,
                    className: 'htCenter htMiddle',
                    source: ["KREDİ KARTI", "NAKİT"]

                };
            }
            if (header === 'ÜLKE') {
                return {
                    type: 'dropdown',
                    strict: true,
                    allowInvalid: false,
                    className: 'htCenter htMiddle',
                    source: [
                        'AFGHANISTAN',
                        'ALBANIA',
                        'ALGERIA',
                        'ANDORRA',
                        'ANGOLA',
                        'ANTIGUA AND BARBUDA',
                        'ARGENTINA',
                        'ARMENIA',
                        'AUSTRALIA',
                        'AUSTRIA',
                        'AZERBAIJAN',
                        'THE BAHAMAS',
                        'BAHRAIN',
                        'BANGLADESH',
                        'BARBADOS',
                        'BELARUS',
                        'BELGIUM',
                        'BELIZE',
                        'BENIN',
                        'BHUTAN',
                        'BOLIVIA',
                        'BOSNIA AND HERZEGOVINA',
                        'BOTSWANA',
                        'BRAZIL',
                        'BRUNEI',
                        'BULGARIA',
                        'BURKINA FASO',
                        'BURUNDI',
                        'CABO VERDE',
                        'CAMBODIA',
                        'CAMEROON',
                        'CANADA',
                        'CENTRAL AFRICAN REPUBLIC',
                        'CHAD',
                        'CHILE',
                        'CHINA',
                        'COLOMBIA',
                        'COMOROS',
                        'CONGO, DEMOCRATIC REPUBLIC OF THE',
                        'CONGO, REPUBLIC OF THE',
                        'COSTA RICA',
                        'CÔTE D’IVOIRE',
                        'CROATIA',
                        'CUBA',
                        'CYPRUS',
                        'CZECH REPUBLIC',
                        'DENMARK',
                        'DJIBOUTI',
                        'DOMINICA',
                        'DOMINICAN REPUBLIC',
                        'EAST TIMOR (TIMOR-LESTE)',
                        'ECUADOR',
                        'EGYPT',
                        'EL SALVADOR',
                        'EQUATORIAL GUINEA',
                        'ERITREA',
                        'ESTONIA',
                        'ESWATINI',
                        'ETHIOPIA',
                        'FIJI',
                        'FINLAND',
                        'FRANCE',
                        'GABON',
                        'THE GAMBIA',
                        'GEORGIA',
                        'GERMANY',
                        'GHANA',
                        'GREECE',
                        'GRENADA',
                        'GUATEMALA',
                        'GUINEA',
                        'GUINEA-BISSAU',
                        'KOSOVO',
                        'GUYANA',
                        'HAITI',
                        'HONDURAS',
                        'HUNGARY',
                        'ICELAND',
                        'INDIA',
                        'INDONESIA',
                        'IRAN',
                        'IRAQ',
                        'IRELAND',
                        'ISRAEL',
                        'ITALY',
                        'JAMAICA',
                        'JAPAN',
                        'JORDAN',
                        'KAZAKHSTAN',
                        'KENYA',
                        'KIRIBATI',
                        'KOREA, NORTH',
                        'KOREA, SOUTH',
                        'KUWAIT',
                        'KYRGYZSTAN',
                        'LAOS',
                        'LEBANON',
                        'LATVIA',
                        'LESOTHO',
                        'LIBERIA',
                        'LIBYA',
                        'LIECHTENSTEIN',
                        'LITHUANIA',
                        'LUXEMBOURG',
                        'MADAGASCAR',
                        'MALAWI',
                        'MALAYSIA',
                        'MALDIVES',
                        'MALI',
                        'MALTA',
                        'MARSHALL ISLANDS',
                        'MAURITANIA',
                        'MAURITIUS',
                        'MEXICO',
                        'MICRONESIA, FEDERATED STATES OF',
                        'MOLDOVA',
                        'MONACO',
                        'MONGOLIA',
                        'MONTENEGRO',
                        'MOROCCO',
                        'MOZAMBIQUE',
                        'MYANMAR (BURMA)',
                        'NAMIBIA',
                        'NAURU',
                        'NEPAL',
                        'NETHERLANDS',
                        'NEW ZEALAND',
                        'NICARAGUA',
                        'NIGER',
                        'NIGERIA',
                        'NORTH MACEDONIA',
                        'NORWAY',
                        'OMAN',
                        'PAKISTAN',
                        'PALAU',
                        'PANAMA',
                        'PAPUA NEW GUINEA',
                        'PARAGUAY',
                        'PERU',
                        'PHILIPPINES',
                        'POLAND',
                        'PORTUGAL',
                        'QATAR',
                        'ROMANIA',
                        'RUSSIA',
                        'RWANDA',
                        'SAINT KITTS AND NEVIS',
                        'SAINT LUCIA',
                        'SAINT VINCENT AND THE GRENADINES',
                        'SAMOA',
                        'SAN MARINO',
                        'SAO TOME AND PRINCIPE',
                        'SAUDI ARABIA',
                        'SENEGAL',
                        'SERBIA',
                        'SEYCHELLES',
                        'SIERRA LEONE',
                        'SINGAPORE',
                        'SLOVAKIA',
                        'SLOVENIA',
                        'SOLOMON ISLANDS',
                        'SOMALIA',
                        'SOUTH AFRICA',
                        'SPAIN',
                        'SRI LANKA',
                        'SUDAN',
                        'SUDAN, SOUTH',
                        'SURINAME',
                        'SWEDEN',
                        'SWITZERLAND',
                        'SYRIA',
                        'TAIWAN',
                        'TAJIKISTAN',
                        'TANZANIA',
                        'THAILAND',
                        'TOGO',
                        'TONGA',
                        'TRINIDAD AND TOBAGO',
                        'TUNISIA',
                        'TURKMENISTAN',
                        'TUVALU',
                        'UGANDA',
                        'UKRAINE',
                        'UNITED ARAB EMIRATES',
                        'UNITED KINGDOM',
                        'UNITED STATES',
                        'URUGUAY',
                        'UZBEKISTAN',
                        'VANUATU',
                        'VATICAN CITY',
                        'VENEZUELA',
                        'VIETNAM',
                        'YEMEN',
                        'ZAMBIA',
                        'ZIMBABWE',
                    ],
                    width: 100
                };
            }
            if (['FATURA TUTARI', 'ÖDENEN İADE TUTARI'].includes(header)) {
                return { type: 'numeric', strict: false, className: 'htCenter htMiddle' };
            }
            if (header === 'LOKASYON') {
                return {
                    type: 'text',
                    strict: false,
                    className: 'htCenter htMiddle',
                    placeholder: parsedUser.firstResponsibleOffice.title,
                    readOnly: true,
                };
            }
            if (header === 'İŞLEM TARİHİ') {
                return {
                    type: 'date',
                    dateFormat: 'DD/MM/YYYY',
                    correctFormat: true,
                    allowInvalid: false,
                    strict: true,
                    className: 'htCenter htMiddle',
                    placeholder: 'GG/AA/YYYY',
                    datePickerConfig: {
                        firstDay: 1,
                        showWeekNumber: true,
                        i18n: {
                            previousMonth: 'Previous Month',
                            nextMonth: 'Next Month',
                            months: [
                                'Ocak',
                                'Şubat',
                                'Mart',
                                'Nisan',
                                'Mayıs',
                                'Haziran',
                                'Temmuz',
                                'Ağustos',
                                'Eylül',
                                'Ekim',
                                'Kasım',
                                'Aralık',
                            ],
                            weekdays: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
                            weekdaysShort: ['Pa', 'Pzt', 'Salı', 'Ça', 'Pe', 'Cu', 'Ct'],
                        },
                    },
                };
            }
            return { strict: false, className: 'htCenter htMiddle' };
        });
    };

    const onAfterChange = (changes, source) => {
        if (!hotRef.current || source === 'setDataAtCell') return;
        const hotInstance = hotRef.current.hotInstance;
        const headers = getColumnHeaders();
        const dataToSet = [];
        changes?.forEach(([row, col, prevValue, newValue]) => {
            if ([3, 4, 9, 11, 12, 13].includes(col) && typeof newValue === 'string') {
                const upperValue = newValue.toLocaleUpperCase('tr-TR');
                if (upperValue !== newValue) {
                    dataToSet.push([row, col, upperValue]);
                }
            }
            if (headers[col].includes('TARİH') && newValue) {
                let formatted = newValue.replace(/\./g, '/').replace(/-/g, '/');
                if (!formatted.includes('/') && formatted.length === 8) {
                    formatted = formatted.replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
                }
                dataToSet.push([row, col, formatted]);
            }
        });
        if (dataToSet.length > 0) {
            hotInstance.setDataAtCell(dataToSet, 'setDataAtCell');
        }
    };

    useEffect(() => {
        if (hotRef.current) {
            const hotInstance = hotRef.current.hotInstance;
            hotInstance.loadData(tableData);
            hotInstance.validateCells();
        }
    }, [tableData]);

    useEffect(() => {
        if (isSuccessModalOpen && hotRef.current) {
            setTimeout(() => {
                hotRef.current.hotInstance.validateCells(() => {
                    hotRef.current.hotInstance.render();
                });
            }, 0);
        }
    }, [isSuccessModalOpen]);


    const handleCreate = () => {
        const hotInstance = hotRef.current.hotInstance;
        const headers = getColumnHeaders();

        hotInstance.validateCells(() => {
            const currentData = hotInstance.getData();
            let validRows = [];
            let errorRows = [];

            currentData.forEach((row, rowIndex) => {
                const rowHasData = row.some((cell, colIndex) => {
                    if (['NO', 'LOKASYON', 'NOT'].includes(headers[colIndex])) return false;
                    return cell && cell.toString().trim() !== '';
                });
                if (!rowHasData) return;

                let rowHasError = false;
                for (let col = 0; col < row.length; col++) {
                    if (['NO', 'LOKASYON', 'NOT'].includes(headers[col])) continue;

                    if (!row[col] || row[col].toString().trim() === '') {
                        rowHasError = true;
                        break;
                    }

                    const meta = hotInstance.getCellMeta(rowIndex, col);
                    if (meta.valid === false) {
                        rowHasError = true;
                        break;
                    }
                }

                if (rowHasError) {
                    errorRows.push(row);
                } else {
                    validRows.push(row);
                }
            });

            if (validRows.length === 0) {
                openSuccessModal('İşlenecek geçerli satır yok.', 0, 'error');
                return;
            }

            const totalRows = 50;
            let newData = [...errorRows];
            const headerCount = headers.length;
            while (newData.length < totalRows) {
                let emptyRow = new Array(headerCount).fill('');
                emptyRow[0] = newData.length + 1;
                newData.push(emptyRow);
            }

            setTableData(newData);

            const reportArray = validRows.map((row) => ({
                brand: row[1],
                operationDate: convertDateFormat(row[2]),
                customerInvoiceNo: row[3],
                customerName: row[4],
                country: row[5],
                price: row[6].toString(),
                returnPrice: row[7].toString(),
                paymentType: row[8],
                store: row[9],
                staff: row[11],
                storeLocation: row[12],
                additionalNote: row[13],
            }));

            Services.CreateOperationReport(parsedUser.token, reportArray, 'tax-free')
                .then((response) => {
                    if (response.data.status) {
                        if (errorRows.length === 0) {
                            openSuccessModal('Geçerli satırlar başarıyla işlendi', 0, 'success');
                        } else {
                            openSuccessModal('Geçerli satırlar işlendi. Hatalı satır sayısı', errorRows.length, 'error');
                        }
                    } else {
                        openSuccessModal('Bir hata meydana geldi.', 0, 'error');
                    }
                })
                .catch(() => {
                    openSuccessModal('Servis çağrısı sırasında hata oluştu.', reportArray.length, 'error');
                });
        });
    };

    const openSuccessModal = (message, count, type) => {
        setSuccessMessage(message);
        setFailedRowsCount(count);
        setModalType(type);
        setSuccessModalOpen(true);
    };

    useEffect(() => {
        if (hotRef.current) {
            const hotInstance = hotRef.current.hotInstance;
            hotInstance.addHook('afterChange', onAfterChange);
            hotInstance.updateSettings({
                data: tableData,
                colHeaders: getColumnHeaders(),
                columns: getColumnSettings(),
            });
        }
    }, [tableData]);

    return (
        <div>
            <Stack direction="row" justifyContent='space-between' mb={2}>
                {tabs}
                <Button onClick={handleCreate} variant="contained" endIcon={<SendIcon />}>
                    {language.commons.save}
                </Button>
            </Stack>
            <Card>
                <Scrollbar>
                    <Box sx={{ width: '100%' }}>
                        <HotTable
                            ref={hotRef}
                            rowHeights={35}
                            licenseKey="non-commercial-and-evaluation"
                            data={tableData}
                            persistentState={true}
                            colHeaders={getColumnHeaders()}
                            columns={getColumnSettings()}
                            stretchH="all"
                            height={calculatedHeight}
                        />
                    </Box>
                </Scrollbar>
            </Card>
            <Modal open={isSuccessModalOpen} onClose={() => setSuccessModalOpen(false)}>
                <Box
                    sx={{
                        position: 'absolute',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                    }}
                >
                    {modalType === 'error' ? (
                        <WarningOutlined sx={{ color: 'orange', fontSize: 64 }} />
                    ) : (
                        <CheckCircleIcon sx={{ color: 'green', fontSize: 64 }} />
                    )}
                    <Typography variant="h6">{successMessage}</Typography>
                    {failedRowsCount > 0 && (
                        <>
                            <Divider sx={{ my: 2, backgroundColor: 'gray' }} />
                            <Typography variant="h6">
                                Uyarı: {failedRowsCount} satırda hata var.
                            </Typography>
                        </>
                    )}
                    <Button
                        onClick={() => {
                            setSuccessModalOpen(false);
                            if (hotRef.current) {
                                setTimeout(() => {
                                    hotRef.current.hotInstance.validateCells(() => {
                                        hotRef.current.hotInstance.render();
                                    });
                                }, 50);
                            }
                        }}
                    >
                        {language.commons.okay}
                    </Button>
                </Box>
            </Modal>
            <ErrorModal />
        </div>
    );
}